import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
} from "@material-ui/core";
import React, { useEffect, useMemo, useState } from "react";

const ChangeOfferPartidaPositionDialog = (props) => {
  const {
    title,
    open,
    setOpen,
    currentPosition,
    totalPositions,
    onSave,
  } = props;

  const [selectedPosition, setSelectedPosition] = useState(currentPosition ?? 0);

  useEffect(() => {
    if (open) {
      setSelectedPosition(currentPosition ?? 0);
    }
  }, [open, currentPosition]);

  const availablePositions = useMemo(() => {
    const count = Number(totalPositions) || 0;
    return Array.from({ length: count }, (_, index) => index);
  }, [totalPositions]);

  return (
    <Dialog
      fullWidth={true}
      maxWidth="xs"
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      aria-labelledby="change-offer-partida-position-dialog"
      className="backdrop"
    >
      <DialogTitle id="change-offer-partida-position-dialog">
        {title || "Cambiar posición"}
      </DialogTitle>
      <DialogContent>
        <TextField
          select
          fullWidth
          label="Nueva posición"
          value={selectedPosition}
          onChange={(event) => setSelectedPosition(Number(event.target.value))}
          InputLabelProps={{ shrink: true }}
          margin="normal"
          variant="outlined"
        >
          {availablePositions.map((position) => (
            <MenuItem key={position} value={position}>
              {position}
            </MenuItem>
          ))}
        </TextField>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setOpen(false);
          }}
          variant="outlined"
        >
          Cancelar
        </Button>
        <Button
          onClick={() => {
            if (typeof onSave === "function") {
              onSave(selectedPosition);
            }
          }}
          variant="outlined"
          color="primary"
        >
          Cambiar posición
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangeOfferPartidaPositionDialog;

